"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
function useDragAndDrop(ref, onFiles) {
    var _a = (0, react_1.useState)(false), isDragOver = _a[0], setDragOver = _a[1];
    var handleDragOver = function (e) {
        e.preventDefault();
        setDragOver(true);
    };
    var handleDragLeave = function () { return setDragOver(false); };
    var handleDrop = function (e) {
        var _a;
        e.preventDefault();
        setDragOver(false);
        var selectedFiles = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files;
        if (selectedFiles) {
            onFiles(selectedFiles);
        }
    };
    react_1.default.useEffect(function () {
        if (ref.current) {
            ref.current.addEventListener('dragover', handleDragOver);
            ref.current.addEventListener('dragleave', handleDragLeave);
            ref.current.addEventListener('drop', handleDrop);
        }
        return function () {
            if (ref.current) {
                ref.current.removeEventListener('dragover', handleDragOver);
                ref.current.removeEventListener('dragleave', handleDragLeave);
                ref.current.removeEventListener('drop', handleDrop);
            }
        };
    }, [ref]);
    return {
        isDragOver: isDragOver,
    };
}
exports.default = useDragAndDrop;
